module.exports = __webpack_public_path__ + "r-v3/img/text_on.810b53ec.svg";